import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';

export abstract class AnagraficaBaseService<TItem> {
  private allItems = new BehaviorSubject<TItem[]>([]);

  constructor(protected http: HttpClient, protected apiBaseUrl: string) {
    this.reloadAll();
  }

  getAll(takeOne = false): Observable<TItem[]> {
    //return this.allItems.pipe(filter(a => a.length > 0), take(takeOne ? 1 : Number.MAX_VALUE));
    return this.allItems.pipe(take(takeOne ? 1 : Number.MAX_VALUE));
  }

  /** Questo metodo semplifica il caricametno in un array gestendo in automatico la sottoscrizione */
  getAllArray(getFn: (items: TItem[]) => void): void {
    this.getInternalAll(true).subscribe(i => getFn([...i]));
  }

  getAsArray(): TItem[] {
    return this.allItems.value;
  }

  create(item: TItem): Observable<TItem> {
    return this.http.post<TItem>(`${this.apiBaseUrl}`, item).pipe(tap(() => this.reloadAll()));
  }

  update(item: TItem): Observable<void> {
    return this.http.put<void>(`${this.apiBaseUrl}/${this.getItemId(item)}`, item).pipe(tap(() => this.reloadAll()));
  }

  delete(item: TItem): Observable<TItem> {
    return this.http.delete<TItem>(`${this.apiBaseUrl}/${this.getItemId(item)}`).pipe(tap(() => this.reloadAll()));
  }

  public getItemId(item: TItem): number | null{
    if (item) {
      return item[this.idProperty as keyof TItem] as number;
    } else {
      return null;
    }
  }

  abstract get nameProperty(): string;
  abstract get idProperty(): string;

  protected reloadAll(): void {
    this.http.get<TItem[]>(`${this.apiBaseUrl}`).subscribe(a => this.allItems.next(a));
  }

  private getInternalAll(takeOne = false): Observable<TItem[]> {
    return this.allItems.pipe(filter(a => a.length > 0), take(takeOne ? 1 : Number.MAX_VALUE));
  }
}
